import { useNavigate } from 'react-router-dom';

export default function Intro() {
  const navigate = useNavigate();

  const handleBusinessLogin = () => {
    navigate('/login');
  };

  const handleWorkerLogin = () => {
    navigate('/workerLogin');
  };

  return (
    <section className="relative overflow-hidden bg-bg text-ink">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_25%,rgba(180,83,9,0.08),transparent_45%),radial-gradient(circle_at_85%_15%,rgba(8,47,73,0.08),transparent_45%)]" />
      <div className="relative mx-auto flex min-h-screen max-w-6xl flex-col justify-center px-6 py-20 md:py-28">
        <p className="w-fit rounded-full border border-border bg-surface/80 px-4 py-1 text-eyebrow uppercase text-ink-3">
          Construction Time Tracking
        </p>

        <h1 className="mt-6 max-w-3xl text-4xl font-semibold tracking-tight text-ink sm:text-5xl md:text-6xl">
          Fraud-free attendance for Construction
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-7 text-ink-2 sm:text-lg">
          TimeStat gives every crew a simple check-in flow using face verification
          and geolocation, without adding more devices or admin overhead.
        </p>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <button
            className="rounded-xl bg-ink px-7 py-3 text-sm font-semibold text-white transition hover:bg-ink-2"
            onClick={handleBusinessLogin}
          >
            Business Login
          </button>
          <button
            className="rounded-xl border border-border bg-surface px-7 py-3 text-sm font-semibold text-ink transition hover:border-ink-3"
            onClick={handleWorkerLogin}
          >
            Worker Login
          </button>
        </div>

        <div className="mt-12 grid max-w-3xl gap-4 sm:grid-cols-3">
          <div className="rounded-2xl border border-border bg-surface/80 p-4">
            <p className="text-eyebrow uppercase text-ink-3">Setup</p>
            <p className="mt-1 text-sm font-semibold text-ink">
              No kiosk hardware required
            </p>
          </div>
          <div className="rounded-2xl border border-border bg-surface/80 p-4">
            <p className="text-eyebrow uppercase text-ink-3">Security</p>
            <p className="mt-1 text-sm font-semibold text-ink">
              Facial liveness + location checks
            </p>
          </div>
          <div className="rounded-2xl border border-border bg-surface/80 p-4">
            <p className="text-eyebrow uppercase text-ink-3">Scale</p>
            <p className="mt-1 text-sm font-semibold text-ink">
              Built for multi-jobsite teams
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
